import { TeamLogo } from "../../../../components/shared/team-logo";
import "./lineup.css";

const pos = (position) => {
  if (!position) return "";
  return String(position).split("/")[0].split(",")[0].trim().toUpperCase();
};

const PlayerName = (props) => {
  const { player_id, player_name, sub } = props;
  const cls = `lineup-name${sub ? " lineup-name--sub" : ""}${player_id ? " lineup-name--link" : ""}`;
  return player_id ? (
    <a href={`/player/${player_id}`} target="_blank" rel="noreferrer" className={cls}>
      {player_name || "Unknown"}
    </a>
  ) : (
    <span className={cls}>{player_name || "Unknown"}</span>
  );
};

export const BattingLineup = (props) => {
  const { lineup, teamName, teamId } = props;

  if (!lineup || lineup.length === 0) {
    return <div className="lineup-empty">No lineup data available</div>;
  }

  const grouped = {};
  const orphanSubs = [];
  lineup.forEach((player) => {
    const order = player.bat_order || 0;
    if (order === 0 && player.is_sub) {
      orphanSubs.push(player);
      return;
    }
    if (!grouped[order]) grouped[order] = [];
    grouped[order].push(player);
  });

  const sortedOrders = Object.keys(grouped).sort((a, b) => Number(a) - Number(b));

  return (
    <div>
      <div className="lineup-header">
        <TeamLogo teamId={teamId} teamName={teamName} size="w-6 h-6" />
        <h3>{teamName}</h3>
      </div>
      <div>
        {sortedOrders.map((order) => {
          const players = grouped[order];
          const starter = players.find((p) => !p.is_sub);
          const subs = players.filter((p) => p.is_sub);
          return (
            <div key={order}>
              {starter && (
                <div className="lineup-row">
                  <span className="lineup-order">{order}</span>
                  <PlayerName player_id={starter.player_id} player_name={starter.player_name} />
                  <span className="lineup-position">{pos(starter.position)}</span>
                </div>
              )}
              {subs.map((sub, idx) => (
                <div key={idx} className="lineup-row lineup-row--sub">
                  <span className="lineup-sub-arrow">↳</span>
                  <PlayerName player_id={sub.player_id} player_name={sub.player_name} sub />
                  <span className="lineup-position">{pos(sub.position)}</span>
                </div>
              ))}
            </div>
          );
        })}
        {orphanSubs.map((sub, idx) => (
          <div key={`orphan-${idx}`} className="lineup-row lineup-row--sub">
            <span className="lineup-sub-arrow">↳</span>
            <PlayerName player_id={sub.player_id} player_name={sub.player_name} sub />
            <span className="lineup-position">{pos(sub.position)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
